// extracted by mini-css-extract-plugin
var _1 = "category-GWAXG";
var _2 = "name-HXUcX";
export { _1 as "category", _2 as "name" }
